import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { PitchCardModalBase } from '../pitchcard-modal-base';
import { DialogModule } from 'primeng/dialog';
import { PlayerMuxComponent } from '@Shared/components/player-mux/player-mux.component';

@Component({
  selector: 'app-pitchcard-video-player-modal',
  standalone: true,

  imports: [DialogModule, PlayerMuxComponent],
  templateUrl: './pitchcard-video-player-modal.component.html'
})
export class PitchCardVideoPlayerModalComponent extends PitchCardModalBase {
  @Input() showVideoPlayerDialog: any;
  @Input() videoReviewId: any;
}
